export const siteConstants = {
  GET_ALL_SUCCESS: "SITES_GET_ALL_SUCCESS",

  GET_SINGLE_SUCCESS: "SITES_GET_SINGLE_SUCCESS",

  REQUEST: "SITES_REQUEST",
  SAVE_SUCCESS: "SITES_SAVE_SUCCESS",
  FAILURE: "SITES_FAILURE",
};
